module.exports = __webpack_public_path__ + "img/15c0d1187844493554ba61f3fa9f5973.svg";